export function etagFromRowVersion(rowVersion?: string | null): string | undefined {
  if (!rowVersion) {
    return undefined;
  }

  return `"${rowVersion}"`;
}

export function isStaleEditStatus(status: number): boolean {
  return status === 412 || status === 428;
}
